import { useCallback, useEffect } from 'react';

import { useLoadingSpinnerStore, useModal } from '@ciam/ui';
import { SetAccountPasswordForm, userValidator, useValidatorStore } from '@features/proxy';
import { useLoginStore } from '@features/shared';
import { useTranslation } from '@ciam/i18n';

export const ValidatePassword = () => {
  const { t } = useTranslation(['proxy', 'schemas']);
  const { isAdUser, isPasswordChangeRequired } = userValidator;
  const { openModal } = useModal();
  const { hideLoading } = useLoadingSpinnerStore();
  const currentUser = useLoginStore((state) => state.currentUser);
  const { setValidateStep } = useValidatorStore();

  const validatePassword = useCallback(() => {
    if (!isAdUser(currentUser) && isPasswordChangeRequired(currentUser)) {
      hideLoading();
      return openModal({
        type: 'alert',
        title: t('reset-password-modal.title'),
        description: [t('reset-password-modal.description')],
        addContent: <SetAccountPasswordForm />,
        hideButtons: true,
      });
    }

    return setValidateStep('user-status-check');
  }, [hideLoading, isAdUser, isPasswordChangeRequired, openModal, setValidateStep, t, currentUser]);

  useEffect(() => {
    validatePassword();
  }, [validatePassword]);

  return null;
};
